import React from 'react';
import { ISvgIconProps, SvgIcon } from './svg-icon.component';

export const HorizontalDotsIcon: React.FC<ISvgIconProps> = (props) => {
    return (
        <SvgIcon size={2.1} sizeIsHeight {...props} viewBox="0 0 26 6" ratio={1}>
           <g transform="translate(-4 -11)" fill={props.color? props.color: "currentColor"}><path d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" transform="translate(14 11)" /><path d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" transform="translate(24 11)" /><path d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z" transform="translate(4 11)" /></g>
        </SvgIcon>
    )
}